import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { f as focusOutline } from '../../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { g as globalStyles, t as transparentStyles, p as primaryStyles, d as defaultStyles, a as transparentloadingStyles, l as loadingStyles } from '../Button.styles-_urruiEm.js';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { I as Icon } from '../../Icon/Icon-BVCquTfq.js';
import { s as spinner } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-B_pWoZ1u-Bxh9jPb6.js';
import { T as Text } from '../../Text/Text-CzvmEXrZ.js';

const normalStyles = /*#__PURE__*/css(["min-height:", ";min-width:", ";font:", ";", ""], ({
  theme
}) => theme.controls.height.base.default, ({
  theme
}) => theme.controls.height.base.default, ({
  theme
}) => theme.font.text.base.default, isMobile(css(["min-height:", ";min-width:", ";font:", ";"], ({
  theme
}) => theme.controls.height.base.mobile, ({
  theme
}) => theme.controls.height.base.mobile, ({
  theme
}) => theme.font.text.base.mobile)));
const smallStyles = /*#__PURE__*/css(["min-height:", ";min-width:", ";font:", ";border-radius:", ";", ""], ({
  theme
}) => theme.controls.height.small.default, ({
  theme
}) => theme.controls.height.small.default, ({
  theme
}) => theme.font.text.small.default, ({
  theme
}) => theme.border.radius.small, isMobile(css(["min-height:", ";min-width:", ";font:", ";"], ({
  theme
}) => theme.controls.height.small.mobile, ({
  theme
}) => theme.controls.height.small.mobile, ({
  theme
}) => theme.font.text.small.mobile)));
const StyledButton = /*#__PURE__*/styled('button').withConfig({
  componentId: "sc-storm-ui-40020072__sc-sbzqoj-0"
})(["box-sizing:border-box;display:flex;align-items:center;justify-content:center;padding:0;", ";", ";", ";", ";&&:focus-visible{", "}margin:0;"], globalStyles, ({
  $variant
}) => {
  if ($variant === 'transparent') {
    return transparentStyles;
  }
  if ($variant === 'primary') {
    return primaryStyles;
  }
  return defaultStyles;
}, ({
  $small
}) => $small ? smallStyles : normalStyles, ({
  $loading,
  $variant
}) => {
  if ($loading) {
    if ($variant === 'transparent') {
      return transparentloadingStyles;
    }
    return loadingStyles;
  }
  return undefined;
}, focusOutline);
const IconButton = ({
  buttonRef,
  children,
  disabled,
  icon,
  label,
  loading,
  loadingLabel,
  onClick,
  small,
  taktId,
  taktValue,
  type = 'button',
  variant = 'default',
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('button')
}, ({
  getDataTaktAttributes
}) => /*#__PURE__*/React__default.createElement(StyledButton, _extends({}, getDataTaktAttributes(), rest, {
  $variant: variant,
  disabled: disabled,
  type: type,
  ref: buttonRef,
  $small: small,
  $loading: loading
}, loading && {
  'aria-live': 'assertive'
}, loading && {
  'aria-disabled': true
}, {
  onClick: loading ? undefined : onClick
}), loading && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Icon, {
  type: spinner,
  size: small ? 'small' : 'base'
}), /*#__PURE__*/React__default.createElement(Text, {
  srOnly: true
}, loadingLabel)), !loading && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Icon, {
  type: icon,
  size: small ? 'small' : 'base'
}), /*#__PURE__*/React__default.createElement(Text, {
  srOnly: true
}, label))));

export { IconButton as I };
//# sourceMappingURL=IconButton-CVOCNw-K.js.map
